import { PostProperties } from "../types";
import image from "../img/lostGemSteveBicknell.jpg";

const post: PostProperties = {
  id: 37,
  title: "Steve Bicknell - Concord Club, Germany (15.12.2001)",
  content: `Steve Bicknell is one of the foundational figures of the genre and a true veteran of the UK techno scene, widely respected for his iconic sound. A key figure in shaping the London underground, he is known for the legendary LOOP parties and countless releases on various labels, which cemented him not only as a great DJ but also as an recognizable producer.`,
  image,
  buttonText: "Listen Here",
  buttonUrl:
    "https://soundcloud.com/shubinproject/steve-bicknell-concord-club-germany-15122001",
  category: "Lost Gem",
  translationsBg: {
    content: `Стив Бикнел е една от основополагащите фигури в жанра и истински ветеран на британската техно сцена, широко уважаван заради емблематичния си звук. Ключова фигура в оформянето на лондонския ъндърграунд, той е известен с легендарните LOOP партита и безбройните си издания за различни лейбъли, които го затвърдиха не само като страхотен диджей, но и като разпознаваем продуцент.`,
  },
};

export default post;
